import React, { useState } from 'react';

import ArrowLeftBoldIcon from 'ati-ui-react/components/icons/ArrowLeftBold';
import ArrowRightBoldIcon from 'ati-ui-react/components/icons/ArrowRightBold';
import theme from 'theme';
import { MainImageStyles, LeftArrow, RightArrow } from './MainImageStyles';

function MainImage({ photos, idCurrentPhoto, setIdCurrentPhoto }) {
  const [isHovered, setHovered] = useState(false);
  const onMouseHandler = (arg) => () => setHovered(arg);

  const leftArrowClickHandler = (e) => {
    e.stopPropagation();
    if (idCurrentPhoto !== 0) {
      setIdCurrentPhoto(idCurrentPhoto - 1);
    } else {
      setIdCurrentPhoto(photos.length - 1);
    }
  };

  const rightArrowClickHandler = (e) => {
    e.stopPropagation();
    if (idCurrentPhoto === photos.length - 1) {
      setIdCurrentPhoto(0);
    } else {
      setIdCurrentPhoto(idCurrentPhoto + 1);
    }
  };

  return (
    <MainImageStyles
      src={photos[idCurrentPhoto]}
      onMouseEnter={onMouseHandler(true)}
      onMouseLeave={onMouseHandler(false)}
    >
      {photos.length > 1 && (
        <>
          <LeftArrow isHovered={isHovered} onClick={leftArrowClickHandler}>
            <ArrowLeftBoldIcon color={theme.colors.color_white} height={60} />
          </LeftArrow>
          <RightArrow isHovered={isHovered} onClick={rightArrowClickHandler}>
            <ArrowRightBoldIcon color={theme.colors.color_white} height={60} />
          </RightArrow>
        </>
      )}
    </MainImageStyles>
  );
}

export default MainImage;
